module.exports = __webpack_public_path__ + "img/box-empty-s-frontal@1x.509d5d5b.png";